const coopenerEmailRegex = /^[\w\u00C0-\u017F!#$%&'+/=?^_`{|}~-]+(\.[\w\u00C0-\u017F!#$%&'*+/=?^_`{|}~-]+)*@[\w\u00C0-\u017F-]+([.][\w\u00C0-\u017F-]+)+$/;

export default coopenerEmailRegex;
